import { Component, Input } from '@angular/core';

import { FormGroup } from '@angular/forms';

@Component({
  template: ` <span class="form-error is-visible">Form Control Component can't be used directly</span> `
})
export class FormControlComponent {
  @Input() controlFormGroup: FormGroup;
  @Input() controlName: string;

  constructor() {}

  /**
   * Determines if the field has errors.
   *
   * @return `true` If the field has errors, `false` if not
   */
  hasErrors(): boolean {
    const control = this.controlFormGroup.controls[this.controlName];
    if (control.errors && control.errors.server) return true;
    if (control.pristine) return false;
    return control.errors ? true : false;
  }
}
